export default "__VITE_ASSET__DSm$0vMR__"